import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Alert, Typography } from '@mui/material';
import { limparPlacar } from '../../services/placarService';

interface CancelScoreConfirmationDialogProps {
  open: boolean;
  placarId: string;
  onClose: () => void;
  onSuccess: () => void;
}

const CancelScoreConfirmationDialog: React.FC<CancelScoreConfirmationDialogProps> = ({
  open,
  placarId,
  onClose,
  onSuccess,
}) => {
  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleConfirm = async () => {
    setProcessing(true);
    setError(null);
    try {
      await limparPlacar(placarId);
      onSuccess();
      onClose();
    } catch (err: any) {
      console.error('Erro ao cancelar resultado:', err);
      setError(err.message || 'Erro ao cancelar resultado');
    } finally {
      setProcessing(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Cancelar Resultado</DialogTitle>
      <DialogContent>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        <Typography variant="body1" sx={{ mb: 2 }}>
          Tem certeza que deseja cancelar o resultado desta partida?
        </Typography>
        <Alert severity="warning">
          Esta ação irá deletar todos os dados do placar da partida (games, tiebreaks e resultado final).
          Esta ação não pode ser desfeita.
        </Alert>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={processing}>
          Cancelar
        </Button>
        <Button onClick={handleConfirm} variant="contained" color="error" disabled={processing}>
          {processing ? 'Processando...' : 'Confirmar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CancelScoreConfirmationDialog;

